import {createSelector, MemoizedSelector} from '@ngrx/store';

import * as fromCitizenServicesRequirement from './citizens-services-requirements.reducer';
import {AppState} from 'src/app/store/reducers';
import {CitizensServices} from '../citizens-services/citizens-services.model';


export const currentState = (state: AppState) => (state[fromCitizenServicesRequirement.citizensServicesRequirementsesFeatureKey]);

export const selectCitizenServiceRequirements = createSelector(currentState, fromCitizenServicesRequirement.selectAll);

export const selectTotolCitizenServiceRequirement = createSelector(currentState, fromCitizenServicesRequirement.selectTotal);

export const selectModifiedServiceRequirement: MemoizedSelector<AppState, any> = createSelector(selectCitizenServiceRequirements, (citizens) => {
  return citizens.map((citizen) => {
    return {
      ...citizen,
      requirement: {
        ...citizen?.requirement,
        modAlternativesRequirements: citizen?.requirement.alternativesRequirements?.map(a => a.requirement?.requirementName)
      }
    };
  });
});


export const selectModifiedServiceRequirementByServiceUuid = (
  serviceUniqueId: string
) =>
  createSelector(selectModifiedServiceRequirement, (categorys: CitizensServices[]) => {
    return categorys.filter(
      (category) =>
        category?.serviceUniqueId === serviceUniqueId
    );
  });
